enum BrokerTypeEnum {
    AustralianCreditLicence = 'AUSTRALIAN_CREDIT_LICENCE',
    AuthorisedCreditRepresentative = 'AUTHORISED_CREDIT_REPRESENTATIVE',
}

export default BrokerTypeEnum;
